import React from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';

import enhancer from '../enhancer';
import type { Activities_admin } from './__generated__/Activities_admin.graphql';

type Props = {
  admin: Activities_admin,
};

const Activities = ({ admin }: Props) => (
  <div>
    <Table>
      <TableHeader>
        <TableRow>
          <TableHeaderColumn>Title</TableHeaderColumn>
          <TableHeaderColumn>Type</TableHeaderColumn>
          <TableHeaderColumn>Message</TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody>
        {admin.allActivities.edges.map(activity => {
          const { node } = activity;

          return (
            <TableRow key={node.id}>
              <TableRowColumn>{node.title}</TableRowColumn>
              <TableRowColumn>{node.type}</TableRowColumn>
              <TableRowColumn>{node.message}</TableRowColumn>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  </div>
);

const query = graphql`
  query ActivitiesAdminQuery {
    admin {
      ...Activities_admin
    }
  }
`;

export default enhancer(Activities, {
  relay: {
    query,
    create: () =>
      createFragmentContainer(Activities, {
        admin: graphql`
          fragment Activities_admin on Admin {
            allActivities(first: 20) {
              edges {
                node {
                  id
                  message
                  type
                  title
                  status
                }
              }
            }
          }
        `,
      }),
  },
});



// WEBPACK FOOTER //
// ./src/components/admin/Activities.js